import BonusForm from "@/components/Front/Bonus/BonusForm";
import DefaultLayout from "@/layouts/DefaultLayout";
import { FetchesData, Pageable } from "kinnect-mixins";

export default {
	name: "BonusEditPage",

	metaInfo: { title: "Update Bonus" },

	mixins: [
		FetchesData,
		Pageable
	],

	render() {
		return <DefaultLayout>
			<BonusForm></BonusForm>
		</DefaultLayout>;
	}
};
